export function normalizeEmptyToNull(value: string | null): string | null {
	return value && value.trim() !== '' ? value : null;
}
